import {Component} from '@angular/core';
import {NavParams, ViewController} from 'ionic-angular';
import {AppConfigService} from "../../services/appConfig.service";
import {UserService} from "../../services/user.services";
import {CommonService} from "../../services/common.service";
import { TranslateService } from 'ng2-translate';

//投注详情
@Component({
    templateUrl: 'reportDTDetails.html',
    selector: 'report-d-t-details-page',
})
export class ReportDTDetailsPage {
    private reportInfo: any;
    private reportSport_Haba: any;
    private reportSport_Banca: any = {gg: 0, ggwin: 0};
    private member: number;
    private newreg: number;
    private lotteryTotal: string;
    private gameTotal: string;
    private taixiuTotal: number = 0;
    private xsNhanhTotal: string;
    private sportTotal: number = 0;
    private sport2Total: number = 0;
    private habaTotal: number = 0;
    private bancaTotal: number = 0;
    private ebetTotal: number = 0;
    private xocdiaTotal: number = 0;
    private baucuaTotal: number = 0;
    private ottTotal: number = 0;
    private totalTongQuan: number = 0;
    private res2list: any;
    private game2lst: any;
    private arrReport: any = [
        {
            value: 'overview',
            title: this.translate.instant('REPORT.OVERVIEW')
        },
        {
            value: 'traditional',
            title: this.translate.instant('REPORT.TRADITIONAL')
        },
        {
            value: 'vip',
            title: this.translate.instant('REPORT.VIP')
        },
        {
            value: 'asia',
            title: this.translate.instant('REPORT.ASIA')
        },
        {
            value: 'speed',
            title: this.translate.instant('REPORT.SPEED')
        },
        {
            value: 'mini',
            title: this.translate.instant('REPORT.MINI')
        }
    ];
    private slDefault = {mode: "overview"};
    private selectAction: string = "overview";

    constructor(public params: NavParams, public viewCtrl: ViewController, private cs: CommonService, private translate: TranslateService) {
        let data = params.get('data');

        this.res2list = data.res2list;
        this.game2lst = data.game2lst;

        this.reportInfo = data.res2list;
        this.reportSport_Haba = data.game2lst;
        let game21st = data.game2lst;
        let res2list = data.res2list;
        this.reportSport_Banca['gg'] = game21st.gg;
        this.reportSport_Banca['ggwin'] = game21st.ggwin;
        this.member = data.member;
        this.newreg = data.newreg;
        this.lotteryTotal = (res2list.mienbacwin + res2list.demienbacwin + res2list.hcmwin + res2list.dongthapwin + res2list.camauwin + res2list.bentrewin + res2list.vungtauwin + res2list.baclieuwin + res2list.dongnaiwin + res2list.canthowin + res2list.soctrangwin + res2list.tayninhwin + res2list.angiangwin + res2list.binhthuanwin + res2list.vinglongwin + res2list.binhduongwin + res2list.travinhwin + res2list.longanwin + res2list.binhphuocwin + res2list.haugiangwin + res2list.tiengiangwin + res2list.kiengiangwin + res2list.dalatwin + res2list.huewin + res2list.phuyenwin + res2list.daclacwin + res2list.quangnamwin + res2list.danangwin + res2list.khanhhoawin + res2list.binhdinhwin + res2list.quangtriwin + res2list.quangbinhwin + res2list.gialaiwin + res2list.ninhthuanwin + res2list.quangngaiwin + res2list.dacnongwin + res2list.kontumwin + res2list.param1
            - res2list.mienbac - res2list.demienbac - res2list.hcm - res2list.dongthap - res2list.camau - res2list.bentre - res2list.vungtau - res2list.baclieu - res2list.dongnai - res2list.cantho - res2list.soctrang - res2list.tayninh - res2list.angiang - res2list.binhthuan - res2list.vinglong - res2list.binhduong - res2list.travinh - res2list.longan - res2list.binhphuoc - res2list.haugiang - res2list.tiengiang - res2list.kiengiang - res2list.dalat - res2list.hue - res2list.phuyen - res2list.daclac - res2list.quangnam - res2list.danang - res2list.khanhhoa - res2list.binhdinh - res2list.quangtri - res2list.quangbinh - res2list.gialai - res2list.ninhthuan - res2list.quangngai - res2list.dacnong - res2list.kontum).toFixed(0);
        this.xsNhanhTotal = (res2list.mmcwin + res2list.xs45swin + res2list.xs1mwin + res2list.xs1m30swin + res2list.xs2mwin + res2list.xs5mwin + res2list.param1
            - res2list.mmc - res2list.xs45s - res2list.xs1m - res2list.xs1m30s - res2list.xs2m - res2list.xs5m).toFixed(0);
        this.gameTotal = (res2list.k3win + res2list.g5win + res2list.zjhwin + res2list.ffk3win - res2list.k3 - res2list.g5 - res2list.zjh - res2list.ffk3 + res2list.param2).toFixed(4);
        this.taixiuTotal = res2list.k3win + res2list.ffk3win + res2list.param1 - res2list.k3 - res2list.ffk3;
        this.sportTotal = game21st.ibcsportwin + res2list.param1 - game21st.ibcsport;
        this.sport2Total = game21st.ibc2sportwin + res2list.param1 - game21st.ibc2sport;
        this.habaTotal = game21st.habawin + res2list.param1 - game21st.haba;
        this.ebetTotal = game21st.ebetwin + res2list.param1 - game21st.ebet;
        this.xocdiaTotal = res2list.xd1swin + res2list.xd1mwin + res2list.param1 - res2list.xd1s - res2list.xd1m;
        this.bancaTotal = game21st.ggwin + res2list.param1 - game21st.gg;
        this.baucuaTotal = res2list.bc1swin + res2list.bc1mwin + res2list.param1 - res2list.bc1s - res2list.bc1m;
        this.ottTotal = res2list.ott1swin + res2list.param1 - res2list.ott1s;

        this.totalTongQuan = this.reportInfo.totalwin +  this.game2lst.totalwin + this.reportInfo.param1+  this.reportInfo.bonus- this.reportInfo.totalbet - this.game2lst.totalbet;
    }
}



// WEBPACK FOOTER //
// ./src/pages/reportDTDetails/reportDTDetails.ts